import axios from 'axios'
import { API } from '../../../common/ApiURL'
import { TokenService } from '../../oauth/token.service'

export const fetchUserInfo = async (): Promise<any> => {
  const config = {
    headers: { authorizationToken: TokenService.getAppToken(), client: 'aiq-desktop', 'Content-Type': 'application/json' },
  }
  try {
    const { data } = await axios.get(API.userInfo, config)
    return data
  } catch (error: any) {
    if (error.response.status === 401) {
      TokenService.refreshToken('UNAUTHENTICATED')
    }
  }
}
